import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { DeleteOrganizationReferenceInput, ProcessedUserPayload } from './generated/types';
import { GqlError } from './GqlError';

export interface RemoveUserResponseBody {
    data: {
        deleteUser: ProcessedUserPayload;
    };
    errors?: Array<GqlError>;
}

export const mutation = `mutation DeleteUser($input: DeleteOrganizationReferenceInput! ) {
    deleteUser(input: $input) {
      id
    }
  }`;

export const useRemoveUser = () => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (removeUserInput: DeleteOrganizationReferenceInput) => {

            await (context.api.graphql({ query: mutation, variables: { input: removeUserInput } }) as Promise<{
                data: {
                    deleteUser: ProcessedUserPayload;
                };
            }>);

            return true;
        },
        onSuccess: (_data, variables) => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', variables.orgId] });
        },
    },
    );
};
